'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const DataLayerPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousUrl = useRef<string | null>(null);

  useEffect(() => {
    const currentUrl = `${window.location.origin}${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

    if (previousUrl.current === currentUrl) return;

    const pageReferrer = previousUrl.current || document.referrer;
    const canonical = document.querySelector('link[rel="canonical"]');
    const canonicalUrl = canonical?.getAttribute('href');

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_url: currentUrl,
        page_referrer: pageReferrer,
        canonical_url: canonicalUrl,
      });
    }

    previousUrl.current = currentUrl;
  }, [pathname, searchParams]);

  return null;
};

export default DataLayerPageView;
